

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav class="wh-sidenav" [disableClose]="true" position="end" #sidenav mode="over" [(opened)]="isSidenavOpen" (closedStart)="onSidenavClosed()">

    <app-therapist-add-edit (formClosed)="sidenav.close()" [therapistId]="activeTherapistId"></app-therapist-add-edit>
    
  </mat-sidenav>
  <mat-sidenav-content class="wh-main">
    <div class="dashboard__content mt-4 pb-5">
      <div class="row mb-4 wh-breadcrumb g-0 text-uppercase">

    <div class="col-auto">
      <span class="small text-muted">Winning Hands Admin</span>
    </div>
    <div class="col-auto">
      <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
    </div>
    <div class="col-auto">
      <a [routerLink]="[ '/', 'admin', 'therapists' ]" class="small text-primary text-decoration-none"> Therapists</a>
    </div>
  </div>
      

        <div class="row mb-4">
            <div class="col-lg col-12">
                <h1 class="mb-0">THERAPISTS</h1>
            </div>
            <div class="col-lg-auto mt-3 mt-lg-0 col-12 d-flex align-items-center justify-content-lg-end">
              @if (isAdmin){
              <button class="d-block d-lg-inline-block w-100" (click)="openSidenav()" mat-flat-button color="primary">ADD THERAPIST</button>
              }
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <mat-form-field appearance="outline" style="width: 100%;">
                    <mat-label>Search therapists</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Hydrogen">
                </mat-form-field>
            </div>
            <!-- <div class="col-lg-4 col-12">
                <mat-form-field appearance="outline" style="width: 100%;">
                    <mat-label>Therapist status</mat-label>
                    <mat-select [(value)]="therapistStatus" (selectionChange)="filterTable($event.value);">
                        <mat-option [value]="0">All</mat-option>
                        <mat-option [value]="1">Offline</mat-option>
                        <mat-option [value]="2">Clocked in</mat-option>
                        <mat-option [value]="3">Available</mat-option>
                        <mat-option [value]="4">On Break</mat-option>

                    </mat-select>
                </mat-form-field>
            </div> -->
        </div>


        <div class="row">
            <div class="col-12" style="width: 100%; overflow-x: auto;">
              <table matSort class="admin-table" mat-table [dataSource]="dataSource">

                <ng-container matColumnDef="image">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let element">
                      <img class="img-fluid rounded-pill"
                           style="width: 40px; height: 40px; margin-right: 15px; min-width:40px;"
                           src="{{getThumbURL(element.profileLargeURL)}}">
                  </td>
                </ng-container>

                <ng-container matColumnDef="firstName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>FIRST NAME</th>
                  <td mat-cell *matCellDef="let element">{{element.firstName}} </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>LAST NAME</th>
                  <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
                </ng-container>

                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>EMAIL</th>
                  <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                </ng-container>


<ng-container matColumnDef="startTime">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>START TIME</th>
                  <td mat-cell *matCellDef="let element"> {{element.startTime}} </td>
                </ng-container>
                <ng-container matColumnDef="endTime">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>END TIME</th>
                  <td mat-cell *matCellDef="let element"> {{element.endTime}} </td>
                </ng-container>
                <ng-container matColumnDef="_therapistStatusID">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</th>
                  <td mat-cell *matCellDef="let element">

                    <span class="badge text-bg-secondary">{{therapistStatusTypeLookup[element.therapistStatusID]}}</span>

                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>@if(isAdmin){ACTIONS}</th>
                  <td mat-cell *matCellDef="let element">
                    @if (isAdmin){
                      


                      <button (click)="openSidenav(element.therapistID)" mat-icon-button aria-label="Edit therapist details">
                      <mat-icon>settings</mat-icon>
                    </button>

                    <button (click)="deleteTherapist(element.therapistID, element.firstName, element.lastName, element.systemUserID)" mat-icon-button aria-label="Delete therapist">
                      <mat-icon>delete</mat-icon>
                    </button>
                    @if (element.therapistStatusID !== 1 && element.therapistStatusID !== 5){
                      <button matTooltip="Clock out {{element.firstName}}" (click)="clockOut(element.therapistID);" mat-icon-button aria-label="Clock out therapist">
                      <mat-icon>alarm_off</mat-icon>
                    </button>
                      }
                    }
                  </td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
        </div>

</div>
  </mat-sidenav-content>
</mat-sidenav-container>


